import {
  CareType,
  OrganizationUtilizationCareType,
  OrganizationUtilizationWeek,
  UtilizationHours,
} from '../../graphQL';

type LegacyUtilizationField = keyof Pick<
  OrganizationUtilizationWeek,
  'psychiatryHours' | 'therapyHours'
>;

const legacyUtilizationFieldByCareType: Partial<Record<CareType, LegacyUtilizationField>> = {
  [CareType.Psychiatry]: 'psychiatryHours',
  [CareType.Therapy]: 'therapyHours',
};

const emptyCareTypeUtilization: UtilizationHours = {
  hoursUtilized: 0,
  hoursScheduled: 0,
  intakesUtilized: 0,
  intakesScheduled: 0,
};

export const getCareTypeUtilization = (
  record: OrganizationUtilizationWeek,
  careType: CareType
): OrganizationUtilizationCareType | UtilizationHours => {
  const careTypeUtilization = record.careTypes.find(
    utilization => utilization.careType === careType
  );

  if (careTypeUtilization) {
    return careTypeUtilization;
  }

  const legacyField = legacyUtilizationFieldByCareType[careType];
  return legacyField ? record[legacyField] : emptyCareTypeUtilization;
};

export const hasCareTypeCapacity = (
  utilization: OrganizationUtilizationCareType | UtilizationHours
) => {
  return utilization.maxHours != null && utilization.maxIntakeHours != null;
};
